export default function() {
    return {
        errorResponse: '',
        successResponse: '',
        user: {
            roles: []
        },
        baseUrl: process.env.VUE_APP_BASE_URL,
        errors: {
            name: null,
            cnpj: null,
            cadastur: null,
            pixKey: null,
            email: null,
            password: null,
            image: null,
            currentImage: null,
            birthDate: null,
            phone: null,
            gender: null,
            rg: null,
            cpf: null,
            zipCode: null,
            state: null,
            city: null,
            address: null,
            addressNumber: null,
            addressNeighbourhood: null,
            contactName: null,
            contactPhone: null,
            description: null
        }
    }
}
